import {useState} from 'react';
import styles from './SlotMachine.module.css';
import './styles.css';

import {SlotMachineGraphic} from './components/Graphic';
import Video from './components/Video';
import SlotMachineLayout from '../slot-machine-wrapper/SlotMachineLayout';
import bushCenter from 'assets/games/theme-cash-stream/slot/footer/footer.png';
import bgTop from 'assets/games/theme-cash-stream/bg-top.png';
import fallingCashNote from 'assets/games/theme-cash-stream/falling-cash-note.png';
import dollar from 'assets/games/theme-cash-stream/dollar.png';

export default function SlotMachineCashStream() {
    const [bgMusicMuted, setBgMusicMuted] = useState(false);

    return (
        <div className={styles.slotMachineContainer}>
            <SlotMachineLayout
                BgWrapper={({children}) => (
                    <div className={styles.slotMachineBg}>
                        {children}
                    </div>
                )}

                InnerWrapper={({children}) => (
                    <div className={styles.SlotMachineInnerContainer}>
                        {children}
                    </div>
                )}
                background={
                    <>
                        <img src={bgTop} alt="LMCT+" className={styles.bgTop}/>
                        <img src={fallingCashNote} alt="LMCT+" className={styles.fallingCashNote}/>
                        <div className={styles.dollarWrapperOne}>
                            <img src={dollar} alt="LMCT+" className={styles.dollarOne}/>
                        </div>
                        <div className={styles.dollarWrapperTwo}>
                            <img src={dollar} alt="LMCT+" className={styles.dollarTwo}/>
                        </div>
                        <div className={styles.dollarWrapperThree}>
                            <img src={dollar} alt="LMCT+" className={styles.dollarThree}/>
                        </div>
                        <div className={styles.dollarWrapperFour}>
                            <img src={dollar} alt="LMCT+" className={styles.dollarFour}/>
                        </div>
                    </>
                }

                graphic={
                    <SlotMachineGraphic/>
                }


                video={
                    <Video bgMusicMuted={bgMusicMuted}/>
                }

                footer={
                    <div className={styles.SlotMachineFooter}>
                        <img src={bushCenter} alt="LMCT+" className={styles.SlotMachineFooterCenterBush}/>
                    </div>
                }

            />
        </div>
    );
}
